import { h as __h } from "preact";
import { Component } from "preact";
import html from "~/util/html.js";
import { adopt, importCss, CSS_MODULE_SCRIPTS } from "~/util/css.js";
const {
  default: sheet
} = CSS_MODULE_SCRIPTS ? await import("./Breadcrumbs.module.css", {
  with: {
    type: "css"
  }
}) : await importCss("./Breadcrumbs.module.css", import.meta.url);
const css = adopt(sheet);
const queue = {
  queued: false,
  notify() {
    if (this.queued) return;
    this.queued = true;
    queueMicrotask(() => {
      this.queued = false;
      for (const fn of crumb.listeners) fn();
    });
  }
};
const crumb = {
  /** @type {Crumb[]} */
  stack: [],
  /** @type {Set<() => void>} */
  listeners: new Set(),
  /** @param {() => void} fn */
  onChange(fn) {
    this.listeners.add(fn);
    return () => this.listeners.delete(fn);
  }
};

/**
 * @extends {Component<CrumbProps>}
 *
 * @typedef {object} CrumbProps
 * @property {boolean} [hidden]
 */
export class Crumb extends Component {
  mounted = false;

  /** @override */
  componentDidUpdate() {
    queue.notify();
  }

  /** @override */
  componentWillUnmount() {
    const index = crumb.stack.indexOf(this);
    if (index === -1) return;
    crumb.stack.splice(index, 1);
    queue.notify();
  }
  render() {
    if (!this.mounted) {
      crumb.stack.push(this);
      this.mounted = true;
      queue.notify();
    }
    return null;
  }
}
export default class Breadcrumbs extends Component {
  /** @override */
  componentDidMount() {
    this.unsub = crumb.onChange(() => this.forceUpdate());
  }

  /** @override */
  componentWillUnmount() {
    this.unsub?.();
  }
  slash() {
    return __h("span", {
      "class": css.slash,
      "aria-hidden": "true"
    });
  }
  render() {
    return __h("div", {
      "class": css.breadcrumbs
    }, crumb.stack.filter(c => !c.props.hidden).map((c, i) => [i ? this.slash() : null, c.props.children]));
  }
}